export const iconWhyChoose = [
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'>
		<path
			d='M13 10h7l-10 14v-8h-7l10-14z'
			fill='var(--svgColor0)'
			style={{ transformOrigin: 'center' }}>
			<animateTransform
				attributeType='XML'
				attributeName='transform'
				type='scale'
				values='1;1.15;1'
				dur='1.5s'
				repeatCount='indefinite'
			/>
		</path>
	</svg>,

	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'>
		<path
			d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'
			fill='var(--svgColor1)'>
			<animateTransform
				attributeType='XML'
				attributeName='transform'
				type='rotate'
				from='0 12 12'
				to='360 12 12'
				dur='3s'
				repeatCount='indefinite'
			/>
		</path>
	</svg>,

	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'>
		<path
			d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z'
			fill='var(--svgColor2)'>
			<animateTransform
				attributeType='XML'
				attributeName='transform'
				type='translate'
				values='0 0; 0 -5; 0 0'
				dur='1s'
				repeatCount='indefinite'
			/>
		</path>
	</svg>,

	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'>
		<path
			fill='var(--svgColor3)'
			d='M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z'>
			<animate
				attributeName='opacity'
				values='1; 0.5; 1'
				dur='1.2s'
				repeatCount='indefinite'
			/>
		</path>
		<path
			fill='var(--svgColor3)'
			d='M13 7h-2v6h6v-2h-4z'>
			<animate
				attributeName='opacity'
				values='1; 0.5; 1'
				dur='1.2s'
				repeatCount='indefinite'
			/>
		</path>
	</svg>,

	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'>
		<path
			d='M12 2a5 5 0 015 5v2a5 5 0 01-10 0V7a5 5 0 015-5zm0 10c3.315 0 6 2.685 6 6v3H6v-3c0-3.315 2.685-6 6-6z'
			fill='var(--svgColor4)'>
			<animateTransform
				attributeType='XML'
				attributeName='transform'
				type='scale'
				values='1;1.05;1.05;1.1;1.05;1'
				dur='2s'
				keyTimes='0;0.2;0.4;0.6;0.8;1'
				repeatCount='indefinite'
			/>
			<animateTransform
				attributeType='XML'
				attributeName='transform'
				type='rotate'
				values='0 12 12;3 12 12;-3 12 12;3 12 12;-3 12 12;0 12 12'
				dur='2s'
				keyTimes='0;0.2;0.4;0.6;0.8;1'
				repeatCount='indefinite'
			/>
		</path>
	</svg>,
];
